//Mui imports
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import BodyTableRow from "./BodyTableRow"

//Store imports
import { useShallow } from 'zustand/react/shallow';
import useStore from "../../store/store";

const FIELDS = [
  ['txFeePerByte'],
  ['txFeeFixed'],
  ['maxBlockBodySize'],
  ['maxTxSize'],
  ['maxBlockHeaderSize'],
  ['stakeAddressDeposit'],
  ['stakePoolDeposit'],
  ['poolRetireMaxEpoch'],
  ['stakePoolTargetNum'],
  ['poolPledgeInfluence'],
  ['monetaryExpansion'],
  ['treasuryCut'],
  ['minPoolCost'],
  ['utxoCostPerByte'],
  ['maxValueSize'],
  ['collateralPercentage'],
  ['maxCollateralInputs'],
  ['committeeMinSize'],
  ['committeeMaxTermLimit'],
  ['govActionLifetime'],
  ['govDeposit'],
  ['dRepDeposit'],
  ['dRepActivity'],
  ['minFeeRefScriptCoinsPerByte'],
  ['executionUnitPrices', 'priceSteps'],
  ['executionUnitPrices', 'priceMemory'],
  ['maxTxExecutionUnits', 'mem'],
  ['maxTxExecutionUnits', 'steps'],
  ['maxBlockExecutionUnits', 'memory'], 
  ['maxBlockExecutionUnits', 'steps'],
  ['poolVotingThresholds', 'committeeNoConfidence'],
  ['poolVotingThresholds', 'committeeNormal'],
  ['poolVotingThresholds', 'hardForkInitiation'],
  ['poolVotingThresholds', 'motionNoConfidence'],
  ['poolVotingThresholds', 'ppSecurityGroup'],
  ['dRepVotingThresholds', 'committeeNoConfidence'],
  ['dRepVotingThresholds', 'committeeNormal'],
  ['dRepVotingThresholds', 'hardForkInitiation'],
  ['dRepVotingThresholds', 'motionNoConfidence'],
  ['dRepVotingThresholds', 'ppEconomicGroup'],
  ['dRepVotingThresholds', 'ppGovernanceGroup'],
  ['dRepVotingThresholds', 'ppNetworkGroup'],
  ['dRepVotingThresholds', 'ppTechnicalGroup'],
  ['dRepVotingThresholds', 'treasuryWithdrawal'],
  ['dRepVotingThresholds', 'updateConstitution'],
];

export default function ParameterView() {
  const { currentJsonState, validationResults, searchValue } = useStore(useShallow(state => ({
    currentJsonState: state.currentJsonState,
    validationResults: state.validationResults,
    searchValue: state.searchValue
  })));

  const getName = (field: string[]) => {
    if (field.length === 1) {
      return field[0];
    } else {
      return `${field[0]}[${field[1]}]`;
    }
  }

  const getValue = (field: string[]) => {
    if (field.length === 1) {
      return (currentJsonState as any || {})[field[0]]?.value;
    } else {
      return (currentJsonState as any || {})[field[0]]?.[field[1]]?.value;
    }
  }

  const getStatus = (field: string[]) => { 
    let paramDetails = (currentJsonState as any || {})[field[0]];  
    if (field.length > 1) {
      paramDetails = paramDetails[field[1]];
    }
    if (paramDetails && paramDetails.checkStatus === 'unchecked') {
      return 'disabled';
    }

    let result = (validationResults as any || {})[field[0]];  
    if (field.length > 1) {
      result = result[field[1]];
    }
   
    if (result) {
      if (result.summaryMandatory === false) {
        return 'inactive';
      } else if (result.summaryMandatory && (result.summary === false)) {
        return 'notMandatory';
      } else {
        return 'active';
      }
    }  
    return 'disabled';
  };

  const filteredFields = searchValue
    ? FIELDS.filter(field => 
        getName(field).toLowerCase().includes(searchValue.toLowerCase())
      )
    : FIELDS;

  return (
    <Table size="small" aria-label="simple table" stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>Parameter Name</TableCell>
          <TableCell align="right">Proposed Value</TableCell>
          <TableCell align="right">Action</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {filteredFields.map((field, index) => (
          <BodyTableRow
            key={index}
            name={getName(field)}
            value={getValue(field)}
            status={getStatus(field)}
          />
        ))}
      </TableBody>
    </Table>
  );
}
